import Configuration, {
  IConfiguration
} from "../../model/config/Configuration";
import { IHttpService } from "../HttpService";

export interface IConfigurationService {
  getConfiguration(): Promise<IConfiguration>;
}

const ConfigurationService = (httpService): IConfigurationService => {
  const _http: IHttpService = httpService;
  const _basePath: string = "/api";
  const _configPath: string = "/config";

  return {
    async getConfiguration() {
      const path = _http.buildPath(_basePath, _configPath);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return Configuration(responseJSON);
    }
  };
};

export default ConfigurationService;
